// Generated by scripts/build-ui-icons.mjs.
export { Eye as default } from "../ui/glyphs-3";
